import React, { FC } from 'react'
import { HERO, CONTACT_US_COPY } from './helpers/constants'
import { handleClick } from './helpers'
import styles from './ArtAdvisory.module.scss'

const Component: FC = () => {
  const { title, description } = HERO
  return (
    <div className={styles.hero} data-type='aa-hero'>
      <div className={styles.container}>
        <h1 className={`${styles.title} defaultTypographyH1 defaultTextUppercase`}>{title}</h1>
        <p className={`${styles.subTitle} defaultTypographyMedium`}>{description}</p>
        <button
          type='button'
          className={`${styles.heroButton} defaultButtonOutlined`}
          onClick={handleClick}
        >
          <p className={`${styles.buttonText} defaultTypographyCtaLarge defaultTextUppercase`}>
            {CONTACT_US_COPY}
          </p>
        </button>
      </div>
      <div className={styles.heroImage}>
        <div className={styles.overlay} />
      </div>
    </div>
  )
}

export default Component
